//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {NsSlottedDropdown} from '@nuskin/design-components';
const DROPDOWN_MAX = 10;

/**
 * QuantitySelector
 *
 * How to use:
 *
 * @event select  When a selection occurs this event emits a function with
 * params: (value, index)
 */

export default {
  name: 'QuantitySelector',
  components: {NsSlottedDropdown},
  model: {
    prop: 'selected',
    event: 'select'
  },
  props: {
    /**
     * Disables input
     */
    disabled: Boolean,
    /**
     * Number of options in the quantity selection dropdown
     */
    dropdownMax: {
      type: Number,
      default: DROPDOWN_MAX
    },
    /**
     * 	If true, the input will take up the full width of its container.
     */
    fullWidth: Boolean,
    /**
     * Include 0
     */
    includeZero: Boolean,
    /**
     * Whether the label should be inline
     */
    inlineLabel: Boolean,
    /**
     * Label (takes priority over translations.quantity)
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * Max quantity available
     */
    maxAvailable: {
      type: Number,
      default: 999
    },
    /**
     * The selected quantity
     */
    selected: {
      type: Number,
      default: 1
    },
    /**
     * The size of the selector.
     * @values small, large
     */
    size: {
      type: String,
      default: 'large'
    },
    /**
     * Error message position
     */
    errorMessagePosition: {
      type: String,
      default: '108%'
    },
    /**
     * Adds 10px of width
     */
    wide: Boolean
  },
  data() {
    return {
      quantityInput: this.dropdownMax || 1,
      selectedValue: this.selected || 1,
      showCustomSelectedItem: false,
      errorMessage: '',
      maxNotUsed: true
    };
  },
  computed: {
    translations() {
      return {
        done: this.$t('generic.done'),
        enter: this.$t('generic.enter'),
        select: this.$t('generic.select'),
        quantity: this.$t('generic.quantity')
      };
    },
    dropdownList() {
      const start = this.includeZero ? 0 : 1;
      const end = Math.min(this.maxAvailable, this.dropdownMax);
      const list = [];
      for (let i = start; i <= end; i++) {
        list.push(i);
      }
      return list;
    },
    widthProp() {
      if (this.fullWidth) {
        return '100%';
      } else {
        return this.wide ? '70' : '60';
      }
    }
  },
  watch: {
    selected: {
      immediate: true,
      handler(newValue) {
        // handle parent changes that are above the dropdownMax
        if (this.useInput(+newValue)) {
          this.showCustomSelectedItem = true;
          this.quantityInput = newValue;
          this.handleInput({target: {value: newValue}});
        } else {
          this.selectedValue = newValue;
        }
      }
    },
    maxAvailable: {
      immediate: true,
      handler(newValue) {
        this.errorCheck();
      }
    }
  },
  methods: {
    /**
     * Checks for invalid quantity
     */
    errorCheck() {
      const maxQuantityText = this.$t('maxQuantityExceeded');
      if (
        maxQuantityText &&
        this.maxAvailable &&
        this.quantityInput > this.maxAvailable
      ) {
        this.errorMessage = maxQuantityText.replace(
          '%stock%',
          this.maxAvailable
        );
      } else {
        this.errorMessage = '';
      }
    },
    handleBlur(event) {
      const value = event.target.value;

      if (!value) {
        this.quantityInput = '';
        this.select(String(this.quantityInput));
      } else {
        this.select(value);
      }
    },
    handleInput(event) {
      const value = event.target.value;
      let quantity = +value || '';
      if (value.length > 3) {
        quantity = +value.slice(0, 3);
      }
      this.quantityInput = String(quantity);

      this.select(this.quantityInput);
      this.selectedValue = this.quantityInput;
      this.showCustomSelectedItem = true;
      this.errorCheck();
    },
    handleKeypress(event) {
      const keyCode = event.keyCode ? event.keyCode : event.which;

      if (event.key === 'Enter') {
        this.$refs.input.blur();
      } else if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    /**
     * Handle variant selection
     */
    handleSelect(value, index) {
      // this allows for showing custom html (via slot) by setting value to 'custom'
      if (value === 'custom') {
        this.showCustomSelectedItem = true;
        this.errorCheck();
        this.quantityInput = this.dropdownMax || '';
        this.select(
          this.dropdownMax,
          this.dropdownMax - this.includeZero ? 0 : 1
        );
        setTimeout(() => {
          this.$refs.input.focus();
          this.$refs.input.select();
        }, 100);
      } else {
        this.errorMessage = '';
        this.showCustomSelectedItem = false;
        this.quantityInput = this.dropdownMax || '';
        this.select(value, index);
      }
    },
    select(value, index) {
      /**
       * Fired when a new quantity is selected: function(value: string|number, index: number) => void
       *
       * @type {select}
       * @property {(string|number)} value data-value attribute of the selected item, or index
       * @property {number} index index of the selected item
       */
      this.$emit('select', value || 0, index || 0);
    },
    useInput(itemQty) {
      return (
        itemQty >= this.dropdownMax && this.maxAvailable > this.dropdownMax
      );
    }
  }
};
